import './src/styles/global.css';

export const shouldUpdateScroll = () => {
    window.scrollTo(0, 0);

    return false;
};
